import { useOutletContext } from "react-router-dom";
import TemplateSelector from "./TemplateSelector";

export default function Dashboard(props) {
    const { dashboard } = useOutletContext();
    const layoutId = dashboard?.dashboard_layout?.id ?? dashboard?.dashboard_layout_id;

    return <TemplateSelector layoutId={layoutId} dashboard={dashboard} />;
}
